import React from "react";
import {
  formatInboxDate,
  notificationSnippet,
} from "../utils/notificationFormatters";

export default function NotificationInboxRow({ item, selected, onSelect }) {
  const subject = item.subject || "Notification";
  const snippet = notificationSnippet(item.notification_message);
  const dateLabel = formatInboxDate(item.created_at);

  return (
    <button
      type="button"
      role="row"
      aria-selected={selected}
      className={`notif-row${selected ? " notif-row--selected" : ""}`}
      onClick={onSelect}
    >
      <span className="notif-row__sender">Girinestham</span>
      <span className="notif-row__content">
        <span className="notif-row__subject">{subject}</span>
        {snippet ? (
          <span className="notif-row__snippet">
            <span className="notif-row__dash" aria-hidden>
              {" "}
              —{" "}
            </span>
            {snippet}
          </span>
        ) : null}
      </span>
      <time className="notif-row__date" dateTime={item.created_at || undefined}>
        {dateLabel}
      </time>
    </button>
  );
}
